/* eslint-disable max-len */
import React from 'react';
import {
  Link,
  Typography,
} from '@material-ui/core';

export const TsAndCs = () => (
  <React.Fragment>
    <Typography variant='body1'>
      Your access to and use of TeleConsult powered by Amazon Chime (TeleConsult) is conditional on your acceptance of and compliance with the AWS Customer Agreement and Acceptable Use Policy (<Link href='https://aws.amazon.com/legal/?nc1=f_cc' rel='noreferrer' target='_blank'>https://aws.amazon.com/legal/?nc1=f_cc</Link>). You represent and warrant that you are authorised to enter into the TeleConsult Terms on behalf of your practice and acknowledge and agree that:
    </Typography>
    <ol>
      <Typography component='li' variant='body1'>
        You own the data that you transmit through or upload to TeleConsult, are solely responsible for its accuracy, legality and quality, and warrant that you have obtained any necessary consents to provide such data to Genie Solutions in order for Genie Solutions to provide TeleConsult to you.
      </Typography>
      <Typography component='li' variant='body1'>
        In order to provide TeleConsult to you, Genie Solutions will be required to collect, use and disclose your data (which may contain Personal Information, including Sensitive Information and Health Information, as defined in the Privacy Act 1988), including the transfer, storage and processing of such data on Genie Solutions’s secure onshore cloud based platforms; and you hereby consent to the transfer, storage and processing of such data arising from your use of TeleConsult on Genie Solutions Australian based cloud service provider for the purpose of providing TeleConsult to you.
      </Typography>
      <Typography component='li' variant='body1'>
        Your use of TeleConsult until October 1st 2020  is complementary, and for use beyond this period Genie Solutions may charge a fee, as determined by Genie Solutions, by giving you one month’s written notice.
      </Typography>
      <Typography component='li' variant='body1'>
        These TeleConsult Terms are in addition to your existing Master Service Agreement or Customer Service Agreement with Genie Solutions and take effect when you access and use TeleConsult.
      </Typography>
      <Typography component='li' variant='body1'>
        Either party may terminate your use of TeleConsult through Genie Solutions and the TeleConsult Terms at any time for convenience by 7 days notice to the other party and Genie Solutions may amend the TeleConsult Terms on 7 days’ notice to you.
      </Typography>
    </ol>
  </React.Fragment>
);

export default TsAndCs;
